import React from "react";

const Notes = ({ note }) => {
  return <React.Fragment>{note}</React.Fragment>;
};

export default Notes;
